export const ObjectNameFormatter = (obj = null) => {
  if (!obj) {
    return;
  }

  return lowercaseKeysDeep(obj);
};

function lowercaseKeysDeep(obj) {
  if (Array.isArray(obj)) {
    return obj.map(lowercaseKeysDeep);
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const lowerKey = key.charAt(0).toLowerCase() + key.slice(1);
      acc[lowerKey] = lowercaseKeysDeep(obj[key]);
      return acc;
    }, {});
  }
  return obj;
}